import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { Box } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import { red } from "@mui/material/colors";
import axios from "axios";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function Adduser() {
  const [loginInput, setLogin] = useState({
    full_name: "",
    username: "",
    phone_number: "",
    country_code: "",
    email: "",
    points: "",
    image: "",
    whatsapp_link: "",
    facebook_link: "",
    instgram_link: "",
    password: "",
    points: "",
    error_list: [],
  });
  const handeleInput = (e) => {
    e.persist();
    setLogin({ ...loginInput, [e.target.name]: e.target.value });
  };

  const loginSubmit = (e) => {
    const data = {
      full_name: loginInput.full_name,
      username: loginInput.username,
      phone_number: loginInput.phone_number,
      country_code: loginInput.country_code,
      email: loginInput.email,
      points: loginInput.points,
      image: loginInput.image,
      whatsapp_link: loginInput.whatsapp_link,
      whatsapp_link: loginInput.whatsapp_link,
      facebook_link: loginInput.facebook_link,
      password: loginInput.password,
      points: loginInput.points,
    };

    axios
      .post(
        `${BaseUrl}/api/users`,
        data
      )
      .then((res) => {
        if (res.data.code === 200) {
        } else {
          setLogin({ ...loginInput, error_list: res.data.error });
        }
      });
  };

  return (
    <React.Fragment>
      <Box class="addusers">
        <Card
          sx={{ maxWidth: 1000 }}
          style={{
            position: "relative",
            top: "50%",
            left: "20%",
          }}
        >
          <CardHeader
            avatar={
              <Avatar
                sx={{ bgcolor: red[500] }}
                aria-label="recipe"
                style={{
                  width: "100px",
                  height: "100px",
                }}
              ></Avatar>
            }
          />

          <Box m="20px">
            <Formik
              initialValues={{
                full_name: "",
                username: "",
                phone_number: "",
                country_code: "",
                email: "",
                level_id: "",
                points: "",
                whatsapp_link: "",
                facebook_link: "",
                instgram_link: "",
                password: "",
              }}
              onSubmit={loginSubmit}
            >
              {({ errors, touched }) => (
                <Form>
                  <Box
                    display="grid"
                    gap="30px"
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  ></Box>
                  <Field
                    name="full_name"
                    fullWidth
                    variant="filled"
                    value={loginInput.full_name}
                    placeholder="full_name"
                    type="text"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.full_name && touched.full_name ? (
                    <div>{errors.full_name}</div>
                  ) : null}
                  <Field
                    name="username"
                    fullWidth
                    variant="filled"
                    value={loginInput.username}
                    placeholder="User Name"
                    type="text"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.username && touched.username ? (
                    <div>{errors.username}</div>
                  ) : null}
                  <Field
                    name="phone_number"
                    fullWidth
                    variant="filled"
                    value={loginInput.phone_number}
                    placeholder="Phone Number"
                    type="text"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.phone_number && touched.phone_number ? (
                    <div>{errors.phone_number}</div>
                  ) : null}
                  <Field
                    name="country_code"
                    fullWidth
                    variant="filled"
                    value={loginInput.country_code}
                    placeholder="Country Code"
                    type="text"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.country_code && touched.country_code ? (
                    <div>{errors.country_code}</div>
                  ) : null}

                  <Field
                    name="email"
                    fullWidth
                    variant="filled"
                    value={loginInput.email}
                    placeholder="email"
                    type="text"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.email && touched.email ? (
                    <div>{errors.email}</div>
                  ) : null}

                  <Field
                    name="points"
                    fullWidth
                    variant="filled"
                    value={loginInput.points}
                    placeholder="Level Id"
                    type="number"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.points && touched.points ? (
                    <div>{errors.points}</div>
                  ) : null}

                  <Field
                    name="whatsapp_link"
                    fullWidth
                    variant="filled"
                    value={loginInput.whatsapp_link}
                    placeholder="whatsapp link"
                    type="text"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.whatsapp_link && touched.whatsapp_link ? (
                    <div>{errors.whatsapp_link}</div>
                  ) : null}

                  <Field
                    name="facebook_link"
                    fullWidth
                    variant="filled"
                    value={loginInput.facebook_link}
                    placeholder="facebook link"
                    type="text"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.facebook_link && touched.facebook_link ? (
                    <div>{errors.facebook_link}</div>
                  ) : null}

                  <Field
                    name="instgram_link"
                    fullWidth
                    variant="filled"
                    value={loginInput.instgram_link}
                    placeholder="instgram link"
                    type="text"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.instgram_link && touched.instgram_link ? (
                    <div>{errors.instgram_link}</div>
                  ) : null}

                  <Field
                    name="password"
                    fullWidth
                    variant="filled"
                    value={loginInput.password}
                    placeholder="password"
                    type="text"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.password && touched.password ? (
                    <div>{errors.password}</div>
                  ) : null}

                  <Box display="flex" justifyContent="end" mt="20px">
                    <button
                      type="submit"
                      color="secondary"
                      variant="contained"
                      style={{
                        background: "#d84444",
                      }}
                    >
                      Submit{" "}
                    </button>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Card>
      </Box>
    </React.Fragment>
  );
}
export default Adduser;
